<template>
    <div>
        <table-tool-bar style="margin-top: 16px;">
            <Button v-if="$can('add')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickAdd">
                新增商品
            </Button>
        </table-tool-bar>
        <Table ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height='mtHeight'>
            <!-- 商品图片 -->
            <template v-slot:avatar="{ row }">
                <base-img :src="row.goodsImg"
                    height="32"
                    width="32"></base-img>
            </template>
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button v-if="$can('update') && row.status == 0"
                    type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="rowClickUpper(row)">上架</Button>
                <Button v-if="$can('update') && row.status == 1"
                    type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="rowClickLower(row)">下架</Button>
                <Button type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="rowClickView(row)">详情</Button>
                <PoptipButton v-if="$can('delete')"
                    text="删除"
                    transfer
                    type="default"
                    title="您确定删除这条记录吗？"
                    :ok="() => { rowConfirmDelete(row) }"></PoptipButton>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch">
        </table-pager>
        <!-- 弹出层 -->
        <smart-modal v-model="modal.showGoods"
            :title="curId ? '新增商品编辑' : '新增商品登记'"
            :width="800"
            :height="520"
            :maskClosable="false"
            :buttons.sync="goodsFormBtns"
            @close-by-confirm="search">
            <form-goods v-if="modal.showGoods"
                :id="curId">
            </form-goods>
        </smart-modal>
    </div>
</template>
<script>
import FormGoods from "./form-goods"
import { getPublicImgUrls } from "_u/helper"
import { goodsList, goodsUpdate, goodsDelete } from "@/api/mall"

const PAGE_SIZE = 20


export default {
    name: "ListMallGoods",

    inject: ['mall'],

    components: {
        FormGoods,
    },

    props: {
        title: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                title: this.title,
            },
            page: {
                total: 0,
                list: [],
            },
            dict: {},
            modal: {
                showGoods: false,
            },
            goodsFormBtns: [],
            curId: "",
        }
    },

    computed: {
        columns() {
            return [{
                    type: "index",
                    title: "序号",
                    align: "center",
                    width: 60
                },
                {
                    key: "title",
                    title: "商品名称",
                    align: "left",
                    minWidth: 200,
                },
                {
                    key: "goodsImg",
                    title: "商品图片",
                    align: "center",
                    minWidth: 150,
                    slot: 'avatar'
                },
                {
                    key: "integral",
                    title: "兑换积分",
                    align: "center",
                    width: 100,
                },
                {
                    key: "num",
                    title: "商品总数",
                    align: "center",
                    width: 100,
                },
                {
                    key: "orderNum",
                    title: "已兑换数",
                    align: "center",
                    width: 100,
                },
                {
                    key: "remain",
                    title: "剩余商品数",
                    align: "center",
                    width: 100,
                },
                {
                    key: "action",
                    title: "操作",
                    align: "center",
                    width: 200,
                    slot: "action",
                },
            ]
        },
    },


    created() {
        this.fetch()
        this.mall.$on("search", this.search)
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight = detector.windowHeight - this.$refs.mt.$el.getBoundingClientRect().top - 80
        })
    },

    watch: {
        title(val) {
            this.filter.title = val
        }
    },

    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                    goodsList(this.filter),
                ])
                .then(args => {
                    var [page] = args

                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.page.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            var list = data.page.list

            list.forEach(v => {
                v.remain = parseInt(v.num) - parseInt(v.orderNum)
                v.goodsImg = getPublicImgUrls(v.goodsImg)[0]
            })
            
            this.page.list = list
            this.page.total = parseInt(data.page.totalCount)
        },

        onClickAdd(e) {
            this.curId = ''
            this.modal.showGoods = true
        },

        rowClickUpper(row) {
            goodsUpdate({
                id: row.id,
                status: 1,
                ver: row.ver,
            }).then(res => {
                this.fetch()
                this.$Message.success("已上架")
            })
        },
        rowClickLower(row) {
            goodsUpdate({
                id: row.id,
                status: 0,
                ver: row.ver,
            }).then(res => {
                this.fetch()
                this.$Message.success("已下架")
            })
        },
        rowClickView(row) {
            this.curId = row.id
            this.modal.showGoods = true
        },
        rowConfirmDelete(row) {
            goodsDelete(row.id)
                .then(res => this.$Message.success(this.$t("tips.delete.success")))
                .then(res => this.fetch())
        },
    },
}
</script>
<style lang="less"
    scoped>
</style>